export default __webpack_public_path__ + "./image/dd69cc1c1c5282a7828eb733d83bf06e.png";